module.exports = require("./../../_gen/starling/extensions/PDParticle");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/extensions/PDParticle.js
// module id = 194
// module chunks = 0